module.exports = __webpack_public_path__ + "static/logoblack-eba4326d20793638d3ba4b1e1e71a7f5.png";